export const environment = {
  // streamUrl:'https://ajoci351fe.execute-api.us-east-2.amazonaws.com/medialive-switch-input',
  streamUrl: "https://1l6y15r3l6.execute-api.us-east-2.amazonaws.com/dev",
  taggerUrl:
    "http://photo-website-us-east-2-069942164843.s3-website.us-east-2.amazonaws.com/",
};